module.exports = __webpack_public_path__ + "img/br-williams-logo.c41f829f.jpg";